import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { CampaignDrawerOpen } from '@finder/shared/services/campaign-drawer/campaign-drawer.interface';
import { CampaignDrawerService } from '@finder/shared/services/campaign-drawer/campaign-drawer.service';

@Injectable()
export abstract class CampaignDrawerGroupBase implements OnDestroy {
    selectedCard = 0;
    activeGroup = false;

    protected destroy$ = new Subject<void>();

    private data$ = new BehaviorSubject<CampaignDrawerOpen | null>(null);
    protected get onDataChange(): Observable<CampaignDrawerOpen> {
        return this.data$.asObservable();
    }

    private _groupId: number;

    constructor(
        protected drawerService: CampaignDrawerService,
    ) {
        this.drawerService.open
            .pipe(
                filter(data =>  data !== null), // Skip the intial one
                takeUntil(this.destroy$)
            )
            .subscribe(data => this.onOpen(data));
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    protected setGroupId(value: number) {
        this._groupId = value;
    }

    private onOpen(data: CampaignDrawerOpen) {
        // Emit for children
        this.data$.next(data);

        // Check to make sure we are the matching group and set values accordingly
        const isGroupMatch = this._groupId === data.groupId;
        this.activeGroup = isGroupMatch;
        this.selectedCard = isGroupMatch ? data.cardIndex : 0;
    }
}
